<app-modal [open]="active" [name]="'decline-success'" (close)="closeDialog()">
  <div modal-header>
    <ng-container *ngIf="batch as result; else singleHeader">
      {{ hasBatchIssues ? "Some Products Weren't Declined." : 'Declined ' + result.declined + (result.declined === 1 ? ' Product.' : ' Products.') }}
    </ng-container>
    <ng-template #singleHeader>{{
      isAtp
        ? "Declined to Sign the ATP."
        : isFixedPrice
        ? "Declined the Offer."
        : "Declined the Invitation."
    }}</ng-template>
  </div>
  <div modal-body>
    <ng-container *ngIf="batch as result; else singleBody">
      <ng-container *ngIf="hasBatchIssues; else fullSuccess">
        <p class="decline-success__message">{{ result.message }}</p>
        <ng-container *ngIf="result.failed.length">
          <p class="decline-success__heading decline-success__heading--failed">Couldn't be declined. Check its status on the list and try again if needed.</p>
          <app-decline-item-list [items]="result.failed" listTestId="decline-result-failed" listLabel="Products that couldn't be declined"></app-decline-item-list>
        </ng-container>
        <ng-container *ngIf="result.skipped.length">
          <p class="decline-success__heading">Already changed</p>
          <app-decline-item-list [items]="result.skipped" listTestId="decline-result-skipped" listLabel="Products already changed"></app-decline-item-list>
        </ng-container>
      </ng-container>
      <ng-template #fullSuccess>You have declined {{ result.declined }} {{ result.declined === 1 ? 'product' : 'products' }}.</ng-template>
    </ng-container>
    <ng-template #singleBody>{{
      isAtp
        ? "You have declined to sign the ATP."
        : isFixedPrice
        ? "You have declined the offer."
        : "You have declined the invitation."
    }}</ng-template>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="decline-success-close"
    (click)="closeDialog()"
  >
    Close
  </button>
</app-modal>
